require("./bootstrap");

import Vue from "vue";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";

Vue.use(Vuelidate);
Vue.use(VueMask);

Vue.component("careers-form", require("./components/CareersForm.vue").default);
Vue.component("user-register", require("./pages/UserRegistration.vue").default);
Vue.component(
    "builder-register",
    require("./pages/BuilderRegister.vue").default
);
Vue.component("seller-register", require("./pages/SellerRegister.vue").default);

Vue.component(
    "request-home",
    require("./components/RequestHome/RequestHomeForm.vue").default
);
Vue.component(
    "agent-partner-form",
    require("./components/AgentPartner/AgentPartnerForm.vue").default
);

Vue.component(
    "seller-lead-form",
    require("./components/SellerLead/SellerLeadForm.vue").default
);
Vue.component(
    "sell-home-online",
    require("./components/Builders/Properties/AddPropertyForm.vue").default
);

Vue.component(
    "callback-modal",
    require("./components/CallbackRequests/CallbackRequestModal.vue").default
);
Vue.component(
    "need-callback-request",
    require("./components/CallbackRequests/NeedCallbackRequest.vue").default
);
// MLS Leads Modal
Vue.component("mls-leads-modal", require("./components/Leads/MLSLeadsModal.vue").default);

// Create Blog
Vue.component("create-blog", require("./components/Blogs/CreateBlog.vue").default);
Vue.component("edit-blog", require("./components/Blogs/EditPost.vue").default);

const app = new Vue({
    el: "#app",
});
